export default __webpack_public_path__ + "static/media/bg3.5750a5ac.png";